import util from '../util'

let controller = 'SolicitacaoMfaFisico'
export default Object.assign({}, util.GetCrud(controller, null), {
  ObterSolicitacoesPendentes: function () {
    return util.Axios.Get(controller)
  },
  AtualizarSituacaoSolicitacao: function (dto) {
    return util.Axios.Put(controller, 'situacao', dto)
  },
  ObterHistorico: function (dto) {
    return util.Axios.GetAll(controller + '/historico', dto)
  }
})